import Vuex from "vuex";
import user from "./user";
import pc from "./pc";
import gamePage from "./gamePage";
import gift from "./gift";
import ga from "./ga";
import { getGameId, getJSON, get } from "./ultile";
import { POPUP_STYLE } from "../components/TipPopUpIframe";

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production", //在非生产环境下，使用严格模式
  state: {
    role: {
      serverId: "",
      serverName: "",
      roleId: "",
      roleName: ""
    },
    pageInfo: { ...window.pageInfo },
    gameId: getGameId(),
    commonTips: "",
    commonTipsStyle: POPUP_STYLE.good,
    giftState: {
      like_award: false,
      like_award_card: "",
      download_award: false,
      download_award_card: ""
    },
    giftListPopupState: false,
    giftNumberGetPopupState: "",

    finishGameConf: false,
    apkUrl: ""
  },
  getters: {
    pageInfo: state => {
      return state.pageInfo;
    },
    finishGameConf: state => {
      return state.finishGameConf;
    },
    giftListPopupState: state => {
      return state.giftListPopupState;
    },
    giftNumberGetPopupState: state => {
      return state.giftNumberGetPopupState;
    },
    gameUrl: state => {
      return state.gamePage.gameUrl ? `//${state.gamePage.gameUrl}` : "";
    },
    footerLink: state => {
      return state.pc.footerLink;
    },
    showFullScreen: state => {
      return state.pc.showFullScreen;
    },
    user: state => {
      return state.user.user;
    },
    roleInfo: state => {
      return state.role;
    },
    gameId: state => {
      return state.gameId;
    },
    commonTips: state => {
      return state.commonTips;
    },
    commonTipsStyle: state => {
      return state.commonTipsStyle;
    },
    showShareTipsFistTime: state => {
      return (
        //只显示一次提示
        state.gamePage.showShareTipsFistTime
      );
    },
    unreadMsg: state => {
      return state.pc.unreadMsg;
    },
    giftState: state => {
      return state.giftState;
    }
  },
  mutations: {
    updateRoleInfo(
      state,
      { roleId = "", roleName = "", serverId = "", serverName = "" }
    ) {
      state.role = {
        serverId: serverId,
        serverName: serverName,
        roleId: roleId,
        roleName: roleName
      };
    },
    updateCommonTips(state, { msg, style = POPUP_STYLE.good }) {
      state.commonTipsStyle = style;
      state.commonTips = msg;
    },
    updateGiftState(state, { action, value }) {
      state.giftState[`${action}_award`] = value;
    },
    updateGiftCard(state, { action, value }) {
      state.giftState[`${action}_award_card`] = value;
    },
    updateState(state, { action, value }) {
      state[action] = value;
    },
    updatePageInfo(state, value) {
      state.pageInfo = Object.assign(state.pageInfo, value);
    },
    updateApk(state, value) {
      state.apkUrl = value;
    }
  },
  actions: {
    getGameConf({ state, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        let type = window.isFbCanvas ? "canvas" : "web";
        get(
          `//m.gm99.com/h5GameConfig/${type}/${state.gameId}.json?v=${window.now_time}`,
          {}
        ).then(res => {
          if (res && res.data) {
            for (let key in res.data) {
              window.pageInfo[key] = res.data[key];
            }
            commit("updatePageInfo", res.data);
          }
          dispatch("gaStatisticsCommon", {
            eventName: "json_load_succ"
          });
          commit("updateState", { action: "finishGameConf", value: true });
          resolve();
        }, reject);
      });
    },
    getGiftState({ state, commit }) {
      return new Promise(resolve => {
        getJSON(
          `//eventsapi.gm99.com/activity/execute?name=h5cardaward&action=selectAward&params={%22gameId%22:${state.gameId}}`,
          {}
        ).then(res => {
          if (!res.errmsg) {
            if (res.data.like_award) {
              commit("updateGiftState", {
                action: "like",
                value: res.data.like_award.is_award
              });
              commit("updateGiftCard", {
                action: "like",
                value: res.data.like_award.card
              });
            }
            if (res.data.download_award) {
              commit("updateGiftState", {
                action: "download",
                value: res.data.download_award.is_award
              });

              commit("updateGiftCard", {
                action: "download",
                value: res.data.download_award.card
              });
            }
          }
          resolve();
        });
      });
    },
    get_save_gift({ state }, type) {
      return new Promise((resolve, reject) => {
        getJSON(
          `//eventsapi.gm99.com/activity/execute?name=h5cardaward&action=getCardGift&params={%22gameId%22:${state.gameId},%22giftType%22:%22${type}%22}`,
          {}
        ).then(res => {
          if (!res.errmsg) {
            resolve(res.data);
          } else {
            reject(res.errmsg);
          }
        });
      });
    },
    getWebsiteInfo({ commit, state }) {
      return new Promise(resolve => {
        getJSON("//m.gm99.com/ajax/get_game_info", {
          gameID: state.gameId
        }).then(res => {
          if (!res.errmsg) {
            commit("updateApk", res.data.apkDownLoadURL);
          }
          resolve();
        });
      });
    }
  },
  modules: {
    user,
    gamePage,
    pc,
    gift,
    ga
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js